import React from 'react';
import { ModalCompleteFeedbackRequestProps } from './types';
import { Button } from '@vtbhome/juicyfront';
import { Body, Footer } from './modal-complete-feedback-request.styles';
import { Field, Form } from 'react-final-form';
import { validate } from '../../lib/form-validate';
import { Typography } from '@shared/ui/typography/typography';
import { EditFormKeys } from '../../config/form-constants';
import { useFeedbackRequestChangeStatusMutation } from '@entities/feedback-request/api/feedback-request-api';
import { CACHE_KEY_FEEDBACK_REQUEST_CHANGE_STATUS } from '@entities/feedback-request/config/api-constants';
import { Textarea } from '@shared/ui/textarea/textarea';
import { Modal } from '@shared/ui/modal/modal';
import { MutateFormFields } from '../../model/types';
import { useResetModalForm } from '@shared/lib/hooks/use-reset-modal-form/use-reset-modal-form';

export const ModalCompleteFeedbackRequest: React.FC<ModalCompleteFeedbackRequestProps> = ({
    feedbackRequestId,
    isShow,
    onClose,
    onAccept,
}) => {
    const [changeFeedbackRequestStatus, feedbackRequestChangeStatusResult] = useFeedbackRequestChangeStatusMutation({
        fixedCacheKey: CACHE_KEY_FEEDBACK_REQUEST_CHANGE_STATUS,
    });
    const formRef = useResetModalForm<MutateFormFields>(isShow);

    const isLoadingMutate = feedbackRequestChangeStatusResult.isLoading;

    const handleSubmit = async (fields: MutateFormFields) => {
        const result = await changeFeedbackRequestStatus({
            id: feedbackRequestId,
            status: 'completed',
            ...fields,
        });
        if (!result.error) {
            onAccept();
        }
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validate}
            render={(form) => {
                formRef.current = form;
                return (
                    <Modal
                        isShow={isShow}
                        variant='modal'
                        size='l'
                        showLine={false}
                        header={<Typography size='h5'>Закрытие обращения</Typography>}
                        footer={
                            <Footer>
                                <Button disabled={isLoadingMutate} buttonType='light' onClick={onClose}>
                                    Отменить
                                </Button>
                                <Button
                                    preloader={isLoadingMutate}
                                    disabled={isLoadingMutate}
                                    buttonType='primary'
                                    onClick={form.handleSubmit}>
                                    Подтвердить
                                </Button>
                            </Footer>
                        }
                        onClose={onClose}>
                        <Body>
                            <Field
                                name={EditFormKeys.StatusComment}
                                render={({ input, meta }) => (
                                    <Textarea
                                        {...input}
                                        label='Комментарий (необязательно)'
                                        placeholder='Введите комментарий'
                                        maxLength={255}
                                        error={meta.touched && meta.error}
                                    />
                                )}
                            />
                        </Body>
                    </Modal>
                );
            }}
        />
    );
};
